import { lazy, Suspense } from "react";
import { BrowserRouter, Route, Routes } from "react-router";
import Layout from "./layout/Layout";

const Home = lazy(() => import("./routes/home/Home"));
const QualityAssurance = lazy(
  () => import("./routes/qualityAssurance/QualityAssurance"),
);
const PullRequests = lazy(() => import("./routes/pullRequests/PullRequests"));
const Services = lazy(() => import("./routes/services/Services"));
const UserAcceptanceTesting = lazy(
  () => import("./routes/uat/UserAcceptanceTesting"),
);

const AppRoutes = () => {
  return (
    <BrowserRouter>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="qualityassurance" element={<QualityAssurance />} />
            <Route
              path="useracceptancetesting"
              element={<UserAcceptanceTesting />}
            />
            <Route path="pullrequests" element={<PullRequests />} />
            <Route path="services" element={<Services />} />
          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
};

export default AppRoutes;
